import { call, put } from 'redux-saga/effects';

import {
    fetchSecretsByGroupIdAPI,
    createSecretByGroupIdAPI,
    fetchWebhookRulesAPI,
    createWebhookRuleAPI,
    deleteWebhookRulesAPI,
} from 'modules/apis';
import * as webhookActions from '../actions';

/**
 * Fetch Secrets by Group ID
 *
 * @method fetchSecretsByGroupIdSaga
 * @type {Generator}
 * @param {Object} action - The redux aciotn
 * @return {Object}
 */
export function* fetchSecretsByGroupIdSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(fetchSecretsByGroupIdAPI, payload);
        yield put(webhookActions.fetchSecretsByGroupId.success(response));
        return response;
    } catch (error) {
        yield put(webhookActions.fetchSecretsByGroupId.error(error));
        return error;
    }
}

/**
 * Create Secret by Group ID
 *
 * @method createSecretByGroupIdSaga
 * @type {Generator}
 * @param {Object} action - The redux aciotn
 * @return {Object}
 */
export function* createSecretByGroupIdSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(createSecretByGroupIdAPI, payload);
        yield put(webhookActions.createSecretByGroupId.success(response));
        return response;
    } catch (error) {
        yield put(webhookActions.createSecretByGroupId.error(error));
        return error;
    }
}

/**
 * Fetch all Webhook Rules by Group ID
 *
 * @method fetchWebhookRulesSaga
 * @type {Generator}
 * @param {Object} action - The redux aciotn
 * @return {Object}
 */
export function* fetchWebhookRulesSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(fetchWebhookRulesAPI, payload);
        yield put(webhookActions.fetchWebhookRules.success(response));
        return response;
    } catch (error) {
        yield put(webhookActions.fetchWebhookRules.error(error));
        return error;
    }
}

/**
 * Create Webhook Rule by Group ID
 *
 * @method createWebhookRuleSaga
 * @type {Generator}
 * @param {Object} action - The redux aciotn
 * @return {Object}
 */
export function* createWebhookRuleSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(createWebhookRuleAPI, payload);
        yield put(webhookActions.createWebhookRule.success(response));
        return response;
    } catch (error) {
        yield put(webhookActions.createWebhookRule.error(error));
        return error;
    }
}

/**
 * Delete Webhook Rules by Group ID
 *
 * @method deleteWebhookRulesSaga
 * @type {Generator}
 * @param {Object} action - The redux aciotn
 * @return {Object}
 */
export function* deleteWebhookRulesSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(deleteWebhookRulesAPI, payload);
        yield put(webhookActions.deleteWebhookRules.success(response));
        return response;
    } catch (error) {
        yield put(webhookActions.deleteWebhookRules.error(error));
        return error;
    }
}
